export default {
  getSettings: (state) => {
    return state.settings || {}
  },
  getExtraSettings: (state) => {
    const settings = state.getSettings
    return settings?.extra_settings && settings.extra_settings.length > 0 ? settings.extra_settings[0] : {}
  }
}
